// extracted by mini-css-extract-plugin
export default {"fade":"Table_fade__qHvB6","modal-backdrop":"Table_modal-backdrop__g7jrc","show":"Table_show__ZkRQ9","TableContainer":"Table_TableContainer__w7WJ6","Table":"Table_Table__LGaHf"};